var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 33,
    viewBox: "0 0 6 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 32.9451L5.88675 27.9451H0.113249L3 32.9451ZM3.5 0.945068V0.445068H2.5V0.945068H3.5ZM3.5 28.4451L3.5 0.945068H2.5L2.5 28.4451H3.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconDown);
export default __webpack_public_path__ + "static/media/ArrowIconDown.412d1e258e3c32627a99dde43d2b4aeb.svg";
export { ForwardRef as ReactComponent };